import React from 'react';
import PlatformOverview from './containers/platform-overview';
import ChartRevenue from './containers/chart-revenue';

function DashboardPage() {
  return (
    <div className="px-7 py-6">
      <PlatformOverview />
      <div className="flex flex-col gap-5 lg:flex-row mt-[21px]">
        <ChartRevenue />
      </div>
    </div>
  );
}

export default DashboardPage;
